import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create();

// Function to set authorization header
export const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('accessToken', token);
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
    localStorage.removeItem('accessToken');
  }
};

// Function to get stored token
export const getAuthToken = () => {
  return localStorage.getItem('accessToken');
};

// Interceptor to add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to handle responses
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token if unauthorized
      setAuthToken(null);
      window.location.href = '/login'; // Redirect to login
    }
    return Promise.reject(error);
  }
);

// Initialize token on app start
export const initializeAuth = () => {
  const token = getAuthToken();
  if (token) {
    setAuthToken(token);
  }
};

export default axiosInstance;
